import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isDeleting: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_MEMBER_LIST:
    case actions.CREATE_MEMBER_LIST_BATCH:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_MEMBER_LIST_END:
    case actions.CREATE_MEMBER_LIST_BATCH_END:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_MEMBER_LISTS:
    case actions.GET_MEMBER_LIST_STATUS_OF_PROGRESS:
    case actions.SEARCH_MEMBER_LIST_BATCH:
    case actions.SEARCH_MEMBER_LIST_BATCH_ROW:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_MEMBER_LISTS_END:
    case actions.GET_MEMBER_LIST_STATUS_OF_PROGRESS_END:
    case actions.SEARCH_MEMBER_LIST_BATCH_END:
    case actions.SEARCH_MEMBER_LIST_BATCH_ROW_END:
      return {
        ...state,
        isSearching: false,
      };
    case actions.DELETE_MEMBER_LIST:
    case actions.DELETE_MEMBER_LIST_BATCH:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_MEMBER_LIST_END:
    case actions.DELETE_MEMBER_LIST_BATCH_END:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
};
